import './home.css';
import { useContext, useState } from 'react';
import { UserContext } from '../context/UserContext';

export default function KreativStudio() {
  const { user } = useContext(UserContext);
  const [showExamples, setShowExamples] = useState(false);

  const card = {
    background: 'rgba(255,255,255,0.03)',
    border: '1px solid rgba(255,255,255,0.10)',
    borderRadius: 12,
    padding: 14,
  };

  const badge = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 10px',
    borderRadius: 999,
    border: '1px solid rgba(255,255,255,0.15)',
    background: 'rgba(255,255,255,0.03)',
    color: '#D4D8DF',
    fontSize: 12,
    lineHeight: '18px',
  };

  return (
    <div className="home-page">
      <section className={user ? 'hero-offset-if-sidebar' : ''} style={{ width: '100vw', margin: 0, padding: 0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin: '0 0 8px' }}>Kreativ‑Studio</h2>
        <p className="hero-desc" style={{ margin: '0 auto 18px', textAlign: 'center', maxWidth: 860 }}>
          Dienstleistungen unserer Grafiker, Designer und Cutter – plus Vermittlung für zukünftige Aufträge zwischen Kreativ‑Team und AP‑N Mitgliedern.
          Hier bekommst du einen schnellen Überblick, wie wir arbeiten und wo du Beispiele findest.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 10, flexWrap: 'wrap', margin: '6px 0 14px' }}>
          <a className="hero-btn-primary" href="/angebot-anfordern" style={{ textDecoration: 'none' }}>Auftrag anfragen</a>
          <button
            type="button"
            className="hero-btn-secondary"
            aria-expanded={showExamples}
            aria-controls="kreativ-studio-examples"
            onClick={() => setShowExamples(v => !v)}
          >
            {showExamples ? 'Beispiele ausblenden' : 'Beispiele ansehen'}
          </button>
        </div>
      </section>

      <section style={{ width: '100%', maxWidth: 1100, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        {showExamples && (
          <div id="kreativ-studio-examples" style={{ ...card, marginBottom: 12 }}>
            <div style={{ fontWeight: 800, marginBottom: 6 }}>Beispiele</div>
            <div style={{ opacity: 0.85, lineHeight: 1.55, fontSize: 14 }}>
              In Kürze findest du hier erste Beispiel‑Arbeiten aus unserem Kreativ‑Team. Diese Sektion dient aktuell als Platzhalter und wird von uns nach und nach mit echten Beispielen, Erläuterungen und Referenzen ergänzt.
            </div>
          </div>
        )}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 12, marginBottom: 12 }}>
          <div style={card}>
            <div style={{ fontWeight: 800, marginBottom: 6 }}>🎨 Grafik & Design</div>
            <div style={{ opacity: 0.85, lineHeight: 1.55, fontSize: 14 }}>
              Overlays, Panels, Alerts, Emotes/Badges, Thumbnails, Banner, Social‑Media‑Assets, Branding‑Pakete.
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
              <span style={badge}>Overlays</span>
              <span style={badge}>Thumbnails</span>
              <span style={badge}>Branding</span>
              <span style={badge}>Emotes</span>
            </div>
          </div>

          <div style={card}>
            <div style={{ fontWeight: 800, marginBottom: 6 }}>🎬 Cutter & Post‑Production</div>
            <div style={{ opacity: 0.85, lineHeight: 1.55, fontSize: 14 }}>
              Schnitt für Clips, Shorts/Reels, Highlight‑Videos, YouTube‑Videos – inkl. Basic Color/Audio, Untertitel (wenn gewünscht) und Export‑Formaten.
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
              <span style={badge}>Shorts</span>
              <span style={badge}>Highlights</span>
              <span style={badge}>YouTube</span>
              <span style={badge}>Reels</span>
            </div>
          </div>

          <div style={card}>
            <div style={{ fontWeight: 800, marginBottom: 6 }}>🤝 Vermittlung</div>
            <div style={{ opacity: 0.85, lineHeight: 1.55, fontSize: 14 }}>
              Du stellst eine Anfrage, wir matchen dich mit passenden Kreativen und koordinieren den Start.
              So bekommst du schnell einen Ansprechpartner und eine saubere Erwartungs‑Klärung.
            </div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 12 }}>
              <a className="hero-btn-primary" href="/angebot-anfordern" style={{ textDecoration: 'none' }}>Jetzt anfragen</a>
              <a className="hero-btn-secondary" href="/leistungen-im-detail" style={{ textDecoration: 'none' }}>Mehr Details</a>
            </div>
          </div>
        </div>

        <div style={card}>
          <div style={{ fontWeight: 800, marginBottom: 8 }}>So läuft ein Auftrag ab</div>
          <ol style={{ margin: 0, paddingLeft: 18, lineHeight: 1.7, opacity: 0.9 }}>
            <li><b>Anfrage senden</b> (Leistung auswählen, Beschreibung, Deadline/Zeitraum, Budget‑Rahmen optional).</li>
            <li><b>Abstimmung</b> (Stil/Referenzen, Formate, Assets/Logos, Plattform‑Ziele).</li>
            <li><b>Umsetzung</b> (erste Entwürfe/Preview, Feedback‑Schleife).</li>
            <li><b>Finalisierung</b> (Export, Übergabe, ggf. kleine Anpassungen).</li>
          </ol>
          <div style={{ marginTop: 10, fontSize: 13, opacity: 0.8 }}>
            Tipp: Wenn du Beispiele sehen willst, schau in die Downloads – dort liegen oft Grafik‑Pakete und Assets.
          </div>
        </div>
      </section>
    </div>
  );
}
